import request from '@/utils/request'

export function getEsgHrInfoList(param, isNotify) {
  return request({
    url: '/api/getEsgHrInfoList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' }, //searched, saved,deleted
    data: param
  })
}
